import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import {
  Card,
  CardContent,
  CardMedia,
  Typography
} from '@material-ui/core';

const styles = theme => ({
  root: {
    maxWidth: '350px',
  },
  media: {
    height: 0,
    paddingTop: '56.25%',
  },
  content: {
    textAlign: 'left',
  },
  name: {
    fontWeight: 600,
    color: '#C0C0C0',
  },
});

class Service extends Component {

  render() {
    const { classes, name, description, image, title } = this.props;
    return (
      <Card className={classes.root}>
        <CardMedia
          className={classes.media}
          image={image}
          title={title}
        />
        <CardContent className={classes.content}>
          <Typography gutterBottom variant="title" component="h3" className={classes.name}>
            {name}
          </Typography>
          <Typography component="p">
            {description}
          </Typography>
        </CardContent>
      </Card>
    );
  }

};

Service.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default withStyles(styles)(Service);



// WEBPACK FOOTER //
// ./src/components/index/Service.js